var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "add-customers" } },
    [
      _c("div", { staticClass: "basic" }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c(
              "el-form",
              {
                ref: "form",
                attrs: {
                  inline: true,
                  model: _vm.form,
                  rules: _vm.rules,
                  size: "small",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      "margin-bottom": "20px",
                      "margin-left": "24px",
                      display: "flex",
                    },
                    attrs: { label: "通讯工具" },
                  },
                  [
                    _c("span", { staticStyle: { margin: "auto 10px" } }, [
                      _vm._v("通讯工具"),
                    ]),
                    _c(
                      "el-checkbox-group",
                      {
                        on: { change: _vm.handleContactChange },
                        model: {
                          value: _vm.selectedContacts,
                          callback: function ($$v) {
                            _vm.selectedContacts = $$v
                          },
                          expression: "selectedContacts",
                        },
                      },
                      _vm._l(_vm.contactOptions, function (item) {
                        return _c(
                          "el-checkbox",
                          {
                            key: item.value,
                            attrs: {
                              label: item.label,
                              value: item.label,
                              disabled: _vm.isCheckboxDisabled(item),
                            },
                          },
                          [_vm._v(" " + _vm._s(item.label) + " ")]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.selectedContacts && _vm.selectedContacts.includes("电话")
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "45%" },
                        attrs: {
                          label: "联系电话",
                          prop: "phone",
                          rules: _vm.selectedContacts.includes("电话")
                            ? _vm.rules.phone
                            : [],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "16",
                            placeholder: "请输入客户电话",
                            clearable: "",
                            oninput:
                              "if (value.length > 16) value = value.slice(0, 16);",
                            disabled:
                              _vm.type == "edit" && !!_vm.originalForm.phone,
                          },
                          on: { blur: _vm.changePhone },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContacts && _vm.selectedContacts.includes("电话")
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "45%" },
                        attrs: {
                          label: "联系电话2",
                          prop: "phone2",
                          rules: _vm.selectedContacts.includes("电话")
                            ? _vm.rules.phone2
                            : [],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "16",
                            placeholder: "请输入客户电话",
                            clearable: "",
                            oninput:
                              "if (value.length > 16) value = value.slice(0, 16);",
                          },
                          model: {
                            value: _vm.form.phone2,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone2",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone2",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContacts && _vm.selectedContacts.includes("微信")
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "45%" },
                        attrs: {
                          label: "微信号",
                          prop: "wechatNo",
                          rules: _vm.selectedContacts.includes("微信")
                            ? _vm.rules.wechatNo
                            : [],
                        },
                        on: { change: _vm.changeWechat },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "20",
                            placeholder: "请输入客户微信号",
                            clearable: "",
                            oninput:
                              "if (value.length > 20) value = value.slice(0, 20);",
                          },
                          model: {
                            value: _vm.form.wechatNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "wechatNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.wechatNo",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.selectedContacts && _vm.selectedContacts.includes("微信")
                  ? _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "45%" },
                        attrs: {
                          label: "微信号2",
                          prop: "wechatNo2",
                          rules: _vm.selectedContacts.includes("微信")
                            ? _vm.rules.wechatNo2
                            : [],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "20",
                            placeholder: "请输入客户微信号2",
                            clearable: "",
                            oninput:
                              "if (value.length > 20) value = value.slice(0, 20);",
                          },
                          model: {
                            value: _vm.form.wechatNo2,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "wechatNo2",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.wechatNo2",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户姓名", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入客户姓名", clearable: "" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "性别" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择性别", clearable: "" },
                        model: {
                          value: _vm.form.gender,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "gender", $$v)
                          },
                          expression: "form.gender",
                        },
                      },
                      _vm._l(_vm.dictionaries.gender, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "年龄", prop: "age" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入客户年龄",
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        maxLength: 3,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.age,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "age",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.age",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "身高（CM）", prop: "tall" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入客户身高（CM）",
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        maxLength: 3,
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.tall,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "tall",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.tall",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "体重（KG）", prop: "weight" } },
                  [
                    _c("el-input", {
                      attrs: {
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        maxLength: 3,
                        placeholder: "请输入客户体重（KG）",
                        clearable: "",
                      },
                      model: {
                        value: _vm.form.weight,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "weight", _vm._n($$v))
                        },
                        expression: "form.weight",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "婚否" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择婚否", clearable: "" },
                        model: {
                          value: _vm.form.marriage,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "marriage", $$v)
                          },
                          expression: "form.marriage",
                        },
                      },
                      _vm._l(_vm.dictionaries.marriage, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "地区", prop: _vm.addressValueState } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.addressOptions,
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeAddress },
                      model: {
                        value: _vm.form.addressValue,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "addressValue", $$v)
                        },
                        expression: "form.addressValue",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { staticClass: "birthday-item", attrs: { label: "生日" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        placeholder: "请选择生日日期",
                        type: "date",
                        format: "yyyy-MM-dd",
                        "value-format": "yyyy-MM-dd",
                        "picker-options": _vm.pickerOptions,
                      },
                      model: {
                        value: _vm.form.birthday,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "birthday", $$v)
                        },
                        expression: "form.birthday",
                      },
                    }),
                  ],
                  1
                ),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "详细地址" } },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: "52",
                            placeholder: "请输入详细地址",
                          },
                          model: {
                            value: _vm.form.detailedAddress,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "detailedAddress", $$v)
                            },
                            expression: "form.detailedAddress",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "QQ号" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "12",
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        placeholder: "请输入QQ号",
                      },
                      model: {
                        value: _vm.form.qqNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "qqNo", $$v)
                        },
                        expression: "form.qqNo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "QQ号2" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "12",
                        oninput: "value=value.replace(/[^0-9.]/g,'')",
                        placeholder: "请输入QQ号2",
                      },
                      model: {
                        value: _vm.form.qqNo2,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "qqNo2", $$v)
                        },
                        expression: "form.qqNo2",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "邮箱" } },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "256", placeholder: "请输入邮箱" },
                      model: {
                        value: _vm.form.email,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "邮箱2" } },
                  [
                    _c("el-input", {
                      attrs: { maxlength: "256", placeholder: "请输入邮箱2" },
                      model: {
                        value: _vm.form.email2,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "email2", $$v)
                        },
                        expression: "form.email2",
                      },
                    }),
                  ],
                  1
                ),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "所属类目", prop: "categoryId" } },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.categoryList,
                            props: {
                              checkStrictly: true,
                              label: "categoryName",
                              value: "id",
                              children: "children",
                            },
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.form.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "categoryId", $$v)
                            },
                            expression: "form.categoryId",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "资源时间" } },
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                            placeholder: "选择日期",
                          },
                          model: {
                            value: _vm.form.ditchTimeStr,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "ditchTimeStr", $$v)
                            },
                            expression: "form.ditchTimeStr",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "渠道号", prop: "userDitch" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          filterable: "",
                          placeholder: "选择渠道号",
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.userDitch,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userDitch", $$v)
                          },
                          expression: "form.userDitch",
                        },
                      },
                      _vm._l(_vm.line, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "其他内容" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "64", placeholder: "请输入" },
                          model: {
                            value: _vm.form.otherContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "otherContent", $$v)
                            },
                            expression: "form.otherContent",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "来源平台", prop: "platformId" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择来源平台",
                              filterable: "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.platformId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "platformId", $$v)
                              },
                              expression: "form.platformId",
                            },
                          },
                          _vm._l(_vm.platformList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "客户类别" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: "请选择客户类别",
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.form.customerCategory,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "customerCategory", $$v)
                              },
                              expression: "form.customerCategory",
                            },
                          },
                          _vm._l(_vm.CategoryType, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                label: item.label,
                                value: item.value,
                                clearable: "",
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "用户说明" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "64", placeholder: "请输入" },
                          model: {
                            value: _vm.form.userDescription,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "userDescription", $$v)
                            },
                            expression: "form.userDescription",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "客户意向", prop: "userIntention" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "选择客户意向",
                            },
                            model: {
                              value: _vm.form.userIntention,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "userIntention", $$v)
                              },
                              expression: "form.userIntention",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.customer_intention,
                            function (item) {
                              return _c("el-option", {
                                key: item.dictId,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户等级", prop: "userLevel" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "", placeholder: "选择客户等级" },
                        model: {
                          value: _vm.form.userLevel,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "userLevel", $$v)
                          },
                          expression: "form.userLevel",
                        },
                      },
                      _vm._l(_vm.dictionaries.customer_level, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: {
                            label: item.dictName,
                            value: String(item.dictId),
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.type != "edit"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "门店" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "52", placeholder: "请输入门店" },
                          model: {
                            value: _vm.form.gateSentry,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "gateSentry", $$v)
                            },
                            expression: "form.gateSentry",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "64%" },
                    attrs: { label: "备注", size: "large" },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        maxlength: "64",
                        placeholder: "请输入",
                      },
                      model: {
                        value: _vm.form.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remark", $$v)
                        },
                        expression: "form.remark",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "btn" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.submitForm("cancel")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("form")
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "repart",
          attrs: {
            title: "重复提示",
            visible: _vm.isRepart,
            width: "640px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRepart = $event
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "center",
                  "font-weight": "bold",
                  color: "#333333",
                },
              },
              [_vm._v("重复提示")]
            ),
          ]),
          [
            _c("div", { staticClass: "popIn" }, [
              _vm._v("检测到该手机虚拟号有以下情况，是否仍然新增录入？"),
            ]),
            !(_vm.infoArr.includes("1") && _vm.infoArr.includes("2"))
              ? _c("div", { staticClass: "popContent" }, [
                  _vm.infoArr.includes("1")
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-left": "20px",
                            "padding-top": "30px",
                          },
                        },
                        [
                          _c("div", { staticClass: "popContent_num" }, [
                            _vm._v("1"),
                          ]),
                          _c("div", { staticClass: "popContent_c" }, [
                            _vm._v("其它客服存在相同的虚拟号的客户"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.infoArr.includes("2")
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-left": "20px",
                            "padding-top": "33px",
                          },
                        },
                        [
                          _c("div", { staticClass: "popContent_num" }, [
                            _vm._v("1"),
                          ]),
                          _c("div", { staticClass: "popContent_c" }, [
                            _vm._v("当前的虚拟号您已录入过"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "popContent" }, [
                  _vm.infoArr.includes("1")
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-left": "20px",
                            "padding-top": "30px",
                          },
                        },
                        [
                          _c("div", { staticClass: "popContent_num" }, [
                            _vm._v("1"),
                          ]),
                          _c("div", { staticClass: "popContent_c" }, [
                            _vm._v("其它客服存在相同的虚拟号的客户"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.infoArr.includes("2")
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "margin-left": "20px",
                            "margin-top": "20px",
                          },
                        },
                        [
                          _c("div", { staticClass: "popContent_num" }, [
                            _vm._v("2"),
                          ]),
                          _c("div", { staticClass: "popContent_c" }, [
                            _vm._v("当前的虚拟号您已录入过"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
            _c("div", {
              staticStyle: {
                width: "640px",
                height: "0px",
                border: "1px solid #D9D9D9",
                "margin-left": "-10px",
                "margin-top": "30px",
                "margin-bottom": "14px",
              },
            }),
            _c("div", { staticClass: "dialog-footer" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c(
                    "el-button",
                    { staticClass: "cancel", on: { click: _vm.clearPhone } },
                    [_vm._v("否 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "affirm",
                      attrs: { type: "primary" },
                      on: { click: _vm.submitF },
                    },
                    [_vm._v("是 ")]
                  ),
                ],
                1
              ),
            ]),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }